'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _portal = require('common/components/portal');

var _portal2 = _interopRequireDefault(_portal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Croppable = _react2['default'].createClass({
    displayName: 'Croppable',


    propTypes: {
        'restrictToParent': _react2['default'].PropTypes.bool,
        'callback': _react2['default'].PropTypes.func,
        'className': _react2['default'].PropTypes.string
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'restrictToParent': false,
            'callback': function callback(rect) {
                console.log('callback sez ', rect);
            },
            'containerClassName': 'croppable-container'
        };
    },

    getInitialState: function getInitialState() {
        return {
            'startX': null,
            'startY': null,
            'endX': null,
            'endY': null,
            'dragging': false,
            'boxIsShown': false
        };
    },

    componentDidMount: function componentDidMount() {},

    componentDidUpdate: function componentDidUpdate(props, state) {
        this.addListeners(state);
    },

    //  ----  BEHAVIOR  -----------------------------------

    // point is {x: x, y: y}
    isInBounds: function isInBounds(point) {

        if (!this.props.restrictToParent) {
            return true;
        }

        var parent = _reactDom2['default'].findDOMNode(this).parentNode;

        if (parent) {

            var rect = parent.getBoundingClientRect();

            if (rect.left < point.x && point.x < rect.right && rect.top < point.y && point.y < rect.bottom) {
                return true;
            }
        } else {
            console.log('restrictToParent specified, but no parent found');
        }

        return false;
    },

    mousedown: function mousedown(e) {

        var point = {
            x: e.pageX,
            y: e.pageY
        };

        if (this.isInBounds(point)) {
            this.setState({
                'dragging': true,
                'boxIsShown': true,
                'startX': point.x,
                'startY': point.y,
                'endX': point.x,
                'endY': point.y
            });
        }

        e.stopPropagation();
        e.preventDefault();
    },

    mouseup: function mouseup(e) {

        this.setState({
            'dragging': false
        });

        this.props.callback({
            'left': this.state.startX,
            'top': this.state.startY,
            'width': this.state.endX - this.state.startX,
            'height': this.state.endY - this.state.startY
        });

        e.stopPropagation();
        e.preventDefault();
    },

    mousemove: function mousemove(e) {
        if (this.state.dragging) {

            var point = {
                x: e.pageX,
                y: e.pageY
            };

            if (this.isInBounds(point)) {
                this.updateEndpoint(point);
            }

            e.stopPropagation();
            e.preventDefault();
        }
    },

    updateEndpoint: function updateEndpoint(point) {
        this.setState({
            'endX': point.x,
            'endY': point.y
        });
    },

    addListeners: function addListeners(state) {
        var state = state || {};
        if (this.state.dragging && !state.dragging) {
            document.addEventListener('mousemove', this.mousemove);
            document.addEventListener('mouseup', this.mouseup);
        } else if (!this.state.dragging && state.dragging) {
            document.removeEventListener('mousemove', this.mousemove);
            document.removeEventListener('mouseup', this.mouseup);
        }
    },

    //  ----  RENDERING  ----------------------------------

    render: function render() {

        var style = {};

        if (this.state.boxIsShown) {

            style.display = 'block';

            style = {
                'border': 'dashed 1px black',
                'position': 'absolute',
                zIndex: 50000,
                'width': this.state.endX - this.state.startX,
                'height': this.state.endY - this.state.startY,
                'left': this.state.startX,
                'top': this.state.startY
            };
        } else {
            style.display = 'none';
        }

        var cropBox = _jsx('div', {
            className: 'cropbox',
            style: style
        }, void 0);

        return _jsx('div', {
            className: this.props.containerClassName,
            onMouseDown: this.mousedown
        }, void 0, this.props.children, _jsx(_portal2['default'], {
            rerenderOnUpdate: true
        }, void 0, cropBox));
    }
});

module.exports = Croppable;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/croppable.jsx
 ** module id = 687
 ** module chunks = 0
 **/